import React, { useState } from 'react';
import { sendPasswordResetEmail } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from '../firebaseConfig';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa'; // Asegúrate de tener iconos, o usa texto simple

const ForgotPasswordModal = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  // Nuevo estado para controlar la vista de éxito dentro del mismo modal
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError(null);

    try {
      // Usar correo personalizado de XCOIN
      const sendPasswordReset = httpsCallable(functions, 'sendCustomPasswordResetEmail');

      try {
        await sendPasswordReset({ email });

        // Mostrar vista de éxito
        setCargando(false);
        setIsSuccess(true);
      } catch (emailError) {
        console.warn('Error con correo personalizado, usando fallback:', emailError);

        // Verificar existencia primero
        const verificarUsuario = httpsCallable(functions, 'verificarUsuarioExistente');
        const respuesta = await verificarUsuario({ email: email });

        if (!respuesta.data.existe) {
          setError("Usuario no encontrado. Verifique ser cliente de XCOIN.");
          setCargando(false);
          return;
        }

        // Fallback al método genérico de Firebase
        await sendPasswordResetEmail(auth, email);
        setCargando(false);
        setIsSuccess(true);
      }

    } catch (err) {
      console.error("Error recuperación:", err);
      // Errores específicos
      if (err.message && err.message.includes('NOT_FOUND')) {
        setError("Error de conexión: La función de verificación no está desplegada en el servidor.");
      } else if (err.code === 'auth/user-not-found') {
        setError('No se encontró ningún usuario con ese correo.');
      } else {
        setError("No se pudo procesar la solicitud. Intente nuevamente.");
      }
      setCargando(false);
    }
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 9999 }} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px', textAlign: 'center' }}>

        {/* VISTA DE ÉXITO */}
        {isSuccess ? (
          <div className="success-view" style={{ padding: '20px 0' }}>
            <div style={{ color: '#28a745', fontSize: '3rem', marginBottom: '15px' }}>
              <FaCheckCircle /> {/* O usa un emoji ✅ si no tienes iconos */}
            </div>
            <h3>¡Correo Enviado!</h3>
            <p style={{ marginTop: '15px', color: '#555', lineHeight: '1.5' }}>
              Hemos enviado un enlace de recuperación a: <br />
              <strong>{email}</strong>
            </p>
            <b style={{ fontSize: '0.9rem', color: '#05034eff', marginTop: '10px' }}>
              Revisa tu bandeja de entrada y la carpeta de SPAM.
            </b>
            <button
              className="btn btn-primary"
              onClick={onClose}
              style={{ marginTop: '25px', width: '100%' }}
            >
              Entendido, cerrar
            </button>
          </div>
        ) : (
          /* VISTA DE FORMULARIO (Original) */
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h3 style={{ margin: 0 }}>Restablecer Contraseña</h3>
              <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
            </div>

            <p style={{ marginBottom: '1rem', textAlign: 'left' }}>
              Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
            </p>

            <div className="input-group" style={{ marginBottom: '1rem' }}>
              <input
                id="forgot-pwd-email"
                name="email"
                type="email"
                placeholder="tu.correo@ejemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
                style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
              />
            </div>

            {error && (
              <div className="alert alert-danger" style={{ padding: '10px', margin: '10px 0', backgroundColor: '#f8d7da', color: '#721c24', fontSize: '0.9rem', borderRadius: '5px', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FaExclamationTriangle /> {/* O emoji ⚠️ */}
                {error}
              </div>
            )}

            <div className="modal-actions" style={{ marginTop: '1.5rem', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={cargando}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" disabled={cargando}>
                {cargando ? "Verificando..." : "Enviar Correo"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;